import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import { v4 as uuidv4 } from 'uuid';
import { LoadCheckbookDetailsCols, IdToolTipChanged, UpdateToolTipText } from '../actions/checkbook-details.actions';
import { AssignSelectedCheckbookDetailsData } from '../actions/search-checkbooks-actions.actions';
import { CloseCheckbooksSidenav } from '../actions/sidenav.actions';

export interface CheckbookDetailsState extends EntityState<any> {
  displayedColumns: { [label: string]: string };
  idOfTooltip: number | null;
  toolTipText: string;
}

export const checkbookDetailsAdapter = createEntityAdapter<any>();

const initialState: CheckbookDetailsState = checkbookDetailsAdapter.getInitialState({
  displayedColumns: {},
  idOfTooltip: null,
  toolTipText: '',
});

export const CheckbookDetailsReducer = createReducer(
  initialState,
  on(LoadCheckbookDetailsCols, (state, { displayedColumns }) => ({
    ...state,
    displayedColumns,
  })),
  on(AssignSelectedCheckbookDetailsData, (state, { selectedCheckbookDetailsData }) => {
    const data = selectedCheckbookDetailsData.map((item: any) => ({ ...item, id: uuidv4() }));

    return {
      ...checkbookDetailsAdapter.setAll(data, state),
    };
  }),
  on(IdToolTipChanged, (state, { idOfTooltip }) => ({
    ...state,
    idOfTooltip,
  })),
  on(UpdateToolTipText, (state, { toolTipText }) => ({
    ...state,
    toolTipText,
  })),
  on(CloseCheckbooksSidenav, () => initialState),
  on(ActiveComponentChanged, () => initialState),
);
